/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useTheme } from '@mui/material/styles';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// import Card from '@mui/material/Card';
// import CardContent from '@mui/material/CardContent';
// import Grid from '@mui/material/Grid';
// import TextField from '@mui/material/TextField';
// import Button from '@mui/material/Button';
// // import Divider from '@mui/material/Divider';
// import Avatar from '@mui/material/Avatar';
// import IconButton from '@mui/material/IconButton';
// import FacebookIcon from '@mui/icons-material/Facebook';
// import TwitterIcon from '@mui/icons-material/Twitter';
// import InstagramIcon from '@mui/icons-material/Instagram';

const Content = () => {
  const theme = useTheme();
 
  // const photos = [
  //   {
  //     src: 'https://assets.maccarianagency.com/backgrounds/img25.jpg',
  //     rows: 1,
  //     cols: 2,
  //   },
  //   {
  //     src: 'https://assets.maccarianagency.com/backgrounds/img22.jpg',
  //     rows: 1,
  //     cols: 1,
  //   },
  //   {
  //     src: 'https://assets.maccarianagency.com/backgrounds/img24.jpg',
  //     rows: 1,
  //     cols: 1,
  //   },
  //   {
  //     src: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
  //     rows: 1,
  //     cols: 2,
  //   },
  // ];

  return (
    <Box>
      <Box paddingX={{ xs: 0, sm: 4, md: 6 }}>
        <Typography variant='h4' align='center'>
        PRABHAT PHERI AND SPECIAL ASSEMBLY
        </Typography><br/>
        <Typography component={'p'} align='left' fontSize = "x-small"> 
        PRE-PRIMARY, CLASSES 1, 2, 4E & 10
        </Typography>
        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        As India celebrates 75 years of Independence, to invoke a feeling of patriotism in the hearts of the people and to promote awareness about the Indian National Flag, ‘Har Ghar Tiranga’ campaign under the aegis of Azadi Ka Amrit Mahotsav was celebrated from 11 August 2022 to 15 August 2022. The students of National Public School Yeshwanthpur participated enthusiastically in various activities listed under the campaign.
        </Typography>
        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        The students of Montessori-III, KG-II and Classes 1 and 2 participated in a Prabhat Pheri Flag Parade on Thursday, 11 August 2022. The students marched around the school campus waving the Indian flag depicting the pride and love for the nation. The students of Class 4E presented their special assembly on Azadi ka Amrit Mahotsav. They reverberated the renowned slogans of the freedom fighters followed by a group song and dance which inspired the spirit of patriotism through their performance. The students of Classes 4 to 8 presented a group song which emphasised on the celebration of life as a proud Indian.
        </Typography>
        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        The students of Class 10 revisited significant milestones that marked the glorious decades through their presentation of the turning points in India’s space mission, break-throughs in scientific inventions, initiative towards the environment and major achievements in a comprehensive way. All the events were well coordinated and evoked a feeling of patriotism very effectively.
        </Typography>

        <Box marginY={4}>
        </Box>
      </Box>
    </Box>
  );
};

export default Content;
